import IC_LOGO from '../assets/ic_logo.svg';
import SCROLL_UP_ARROW from '../assets/scroll_up_arrow.svg';

function Footer() {
  return (
    <div className="footer-container">
      <div className="container p-3 text-white">
        <div className="row gx-4 gy-2">
          <div className="col-12 col-lg-6">
            <img src={IC_LOGO} alt="" style={{ width: 120 }} />
            <div className="pt-3">
              Green Vision Eco is a Net Zero real-world asset (RWA) platform focused on land
              afforestation and restoration. Using eco-friendly planting methods and diverse
              species, we empower individuals, businesses, and governments to achieve Net Zero
              goals while driving economic growth. Our projects generate revenue through
              products, honey production, carbon credits, and renewable energy, all while
              revitalizing land and supporting local communities.
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-2 d-flex flex-column row-gap-2 pt-3">
            <div className="fs-5">Online</div>
            <a className="footer-link" href="\">Referral Contest</a>
            <a className="footer-link" href="\">NFT Airdrop</a>
            <a className="footer-link" href="\">Claim</a>
            <a className="footer-link" href="\">Map</a>
            <a className="footer-link" href="\">Profile</a>
          </div>
          <div className="col-6 col-md-4 col-lg-2 d-flex flex-column row-gap-2 pt-3">
            <div className="fs-5">About</div>
            <a className="footer-link" href="\">Telegram</a>
            <a className="footer-link" href="\">Twitter</a>
            <a className="footer-link" href="\">Youtube</a>
            <a className="footer-link" href="\">Instagram</a>
          </div>
          <div className="col-12 col-md-4 col-lg-2 d-flex flex-column pt-3">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-column row-gap-2">
                <div className="fs-5">Links</div>
                <a className="footer-link" href="\">OpenSea</a>
                <a className="footer-link" href="\">Blocktobay</a>
              </div>
              <button style={{ width: 'fit-content', height: 'fit-content' }} type="submit" className="p-0 bg-transparent border-0" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>
                <img src={SCROLL_UP_ARROW} alt="SCROLL_UP_ARROW" />
              </button>
            </div>
          </div>
        </div>
        <div className="divider my-3" />
        <div className="fs-small">© 2024 Green Vision. All Rights Reserved</div>
      </div>
    </div>
  );
}

export default Footer;
